module.exports = __webpack_public_path__ + "img/tooltip_15-vallone-litho-limestone-clay.158081a8.jpg";